import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useRef, useContext } from 'react';
import { Notification } from '../../components/Notification/Notification.es.js';
import { StyledNotification } from '../../components/Notification/styled.es.js';
import styled from 'styled-components';
import { zIndex, spacing } from '../../utils/theme.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { useBreakpoint } from '../useBreakpoint/useBreakpoint.es.js';
import { Portal } from '../../primitives/Portal/Portal.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var ToastContext =
/*#__PURE__*/
React.createContext({
  addToast: function addToast() {
    return void 0;
  },
  closeToast: function closeToast() {
    return void 0;
  }
});
var ToastWrapper = styled(Box).withConfig({
  componentId: "zhj0cm-0"
})(["display:flex;pointer-events:none;position:fixed;width:100%;z-index:", ";opacity:", ";transition:opacity 300ms ease-in-out,bottom 300ms ease-in-out;flex-direction:column;align-items:", ";", "{margin-bottom:", ";margin-right:", ";pointer-events:all;}"], zIndex("alert"), function (_ref) {
  var shouldHideToasts = _ref.shouldHideToasts;
  return shouldHideToasts ? 0 : 1;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? "center" : "flex-end";
}, StyledNotification, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? spacing("xs") : spacing("md");
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 0 : spacing("md");
});

var ToastProvider = function ToastProvider(_ref5) {
  var _ref5$toastBottomMarg = _ref5.toastBottomMargin,
      toastBottomMargin = _ref5$toastBottomMarg === void 0 ? 0 : _ref5$toastBottomMarg,
      _ref5$shouldHideToast = _ref5.shouldHideToasts,
      shouldHideToasts = _ref5$shouldHideToast === void 0 ? false : _ref5$shouldHideToast,
      children = _ref5.children;

  var _useState = useState(
  /* @__PURE__ */
  new Map()),
      toastMap = _useState[0],
      setToastMap = _useState[1];

  var toastCounter = useRef(0);
  var isMobile = useBreakpoint("md");

  var incrementCounter = function incrementCounter() {
    toastCounter.current += 1;
  };

  var closeToast = function closeToast(key) {
    var _a;

    var toast = toastMap.get(key);
    (_a = toast == null ? void 0 : toast.onClose) == null ? void 0 : _a.call(toast);
    toastMap.delete(key);
    setToastMap(new Map(toastMap));
  };

  var addToast = function addToast(toast) {
    incrementCounter();
    var current = toastCounter.current;
    toastMap.set(toast.id || current.toString(), __spreadProps(__spreadValues({}, toast), {
      timeout: toast.timeout
    }));
    setToastMap(new Map(toastMap));
  };

  return (
    /* @__PURE__ */
    React.createElement(ToastContext.Provider, {
      value: {
        addToast: addToast,
        closeToast: closeToast
      }
    },
    /* @__PURE__ */
    React.createElement(Portal, {
      zIndex: 2e3
    },
    /* @__PURE__ */
    React.createElement(ToastWrapper, {
      shouldHideToasts: shouldHideToasts,
      isMobile: isMobile,
      right: 0,
      bottom: toastBottomMargin
    }, _toConsumableArray(toastMap).map(function (_a) {
      var key = _a[0],
          _b = _a[1],
          _c = _b,
          content = _c.content,
          rest = __objRest(_c, ["content"]);

      return (
        /* @__PURE__ */
        React.createElement(Notification, __spreadValues({
          key: key,
          kind: "persistent",
          onClose: function onClose() {
            closeToast(key);
          }
        }, rest), content)
      );
    }))), children)
  );
};

var useToast = function useToast() {
  return useContext(ToastContext);
};

export { ToastProvider, useToast };